import { api_GET, api_POST } from "../api/_axios.js";

const nfpscontrato_api =
{
    getHistorico: function (contrato_Id) {
        const promise = new Promise((resolve, reject) => {
            api_GET(`nfpscontrato/${contrato_Id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
    postNFPS: function (json_submit) {
        const promise = new Promise((resolve, reject) => {
            api_POST(`nfpscontrato`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default nfpscontrato_api;
